import { FooterModal, ModalContainer, ModalWrapper } from "./style";
import Button from "../button";
import React, { useEffect } from "react";

const Index = props => {
  useEffect(() => {
    if (props.show) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [props.show]);
  return (
    <ModalWrapper show={props.show}>
      <div
        className="overlay"
        onClick={props.closeHandler ? () => props.closeHandler() : () => {}}
      />
      <ModalContainer>
        {props.image && (
          <div className="image">
            <img
              src={props.image.src}
              alt={props.image ? props.image.alt : ""}
            />
          </div>
        )}
        <div className="content">
          {props.icon && <i className={`icon ${props.icon}`} />}
          {props.imageIcon && (
            <img src={`/images/${props.imageIcon}`} alt="icon" />
          )}
          {props.title && <span>{props.title}</span>}
          <p dangerouslySetInnerHTML={{ __html: props.description }} />
          {props.children}
        </div>
        <FooterModal>
          <div className="right">
            {props.rightButtons &&
              props.rightButtons.length > 0 &&
              props.rightButtons.map((button, i) => {
                return (
                  <Button
                    btn={button.type}
                    onClick={e => {
                      e.stopPropagation();
                      button.onClick();
                    }}
                    borderless={button.borderless}
                    key={i}
                  >
                    {button.title}
                  </Button>
                );
              })}
            {props.label && <span className="label">{props.label}</span>}
          </div>
          <div className="left">
            {props.leftButtons &&
              props.leftButtons.length > 0 &&
              props.leftButtons.map((button, i) => {
                return (
                  <Button
                    className="button"
                    btn={button.type}
                    onClick={e => {
                      e.stopPropagation();
                      button.onClick();
                    }}
                    borderless={button.borderless}
                    key={i}
                  >
                    {button.title}
                  </Button>
                );
              })}
          </div>
        </FooterModal>
      </ModalContainer>
    </ModalWrapper>
  );
};

export default Index;
